import React from 'react';
import InnerFilterContent, {
  FilterInnerContentProps,
} from '../../../../common/DropdownContent/DynamicFilterInnerContent';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { AssetTransactionStatus } from '../../../../../../../types/asset_transaction/assetTransaction';

export default function AssetTransactionStatusFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<AssetTransactionStatus>) {
  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.assetTransactionStatus || [])]}
      text={item => t(item as TranslationKey).singular.label}
      onRemove={i => {
        filterProps.assetTransactionStatus?.delete(i);
        if (!filterProps.assetTransactionStatus?.size) filterProps.assetTransactionStatus = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
